import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="bg-dark text-white pt-5 pb-3">
            <Container>
                <Row className="gy-4">
                    <Col lg={4} md={6}>
                        <h5 className="mb-3">Paracha Dental Clinic</h5>
                        <p>Providing quality dental care with modern technology and experienced professionals.</p>
                        <div className="d-flex gap-3 mt-3">
                            <a href="https://www.instagram.com/maliha571/" target='_blank' className="text-white"><FaInstagram size={24} /></a>
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <h5 className="mb-3">Quick Links</h5>
                        <ul className="list-unstyled">
                            <li><Link to="/" className="text-white text-decoration-none">Home</Link></li>
                            <li><Link to="/about" className="text-white text-decoration-none">About Us</Link></li>
                            <li><Link to="/services" className="text-white text-decoration-none">Services</Link></li>
                            <li><Link to="/doctors" className="text-white text-decoration-none">Doctors</Link></li>
                            <li><Link to="/contact" className="text-white text-decoration-none">Contact</Link></li>
                        </ul>
                    </Col>
                    <Col lg={3} md={6}>
                        <h5 className="mb-3">Contact Info</h5>
                        <div className="d-flex align-items-center mb-2"><FaMapMarkerAlt className="me-2" /><span>Gulshan-E-Iqbal, Karachi, Pakistan.</span></div>
                        <div className="d-flex align-items-center mb-2"><FaPhone className="me-2" /><span>+92 300 257 3177</span></div>
                        <div className="d-flex align-items-center"><FaEnvelope className="me-2" /><span>consult@parachadental.com</span></div>
                    </Col>
                    <Col lg={3} md={6}>
                        <div className='timing-schedule'>
                            <h4 className="mb-3">Working Hours</h4>
                            <div className='working-time'>
                                <h5 >Morning Timing:</h5>
                                <p className="mb-1">Monday - Thursday: 10:30 AM - 12:30 PM</p>
                            </div>
                            <div className='working-time'>
                                <h5>Evening Timing:</h5>
                                <p className="mb-1">Monday - Saturday: 6:30 PM - 8:30 PM</p>
                                <p>Sunday: Closed</p>
                            </div>
                        </div>
                    </Col>
                </Row>
                <hr className="mt-4" />
                <div className="text-center pt-3"><p className="mb-0">&copy; 2024 Paracha Dental Clinic. All rights reserved.</p></div>
            </Container>
        </footer>
    );
};

export default Footer;